import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_DECLARATION_SUCCESS,
  UPDATE_REVIEW_FAILURE,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from './../actions/types'

function updatePaygIncomesStructure(review) {
  review.incomes = Object.values(review.incomes)

  review.incomes.map((income) => {
    if (income.additionalPaygIncomes) {

      const details = Object.values(income.additionalPaygIncomes).reduce((acc, detail) => {
        acc[detail.paygIncomeType] = detail
        acc[detail.paygIncomeType]['active'] = true

        return acc
      }, {})

      income.additionalPaygIncomes = details
    }
  })

  return review
}

const review = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      const { review } = payload.applicationFlow
      if (review && review.incomes) {
        return updatePaygIncomesStructure(review)
      }

      return state

    case UPDATE_REVIEW_FAILURE:
    case UPDATE_DECLARATION_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      const { review: review2 } = payload

      if (review2 && review2.incomes) {
        return updatePaygIncomesStructure(review2)
      }

      return state

    default:
      return state
  }
}

export default review;
